import { createRoot } from "react-dom/client"
import { RepositoriesPage } from "./pages/RepositoriesPage"
import { RepositoryClonePage } from "./pages/RepositoryClonePage"
import { RepositoryOnboardingPage } from "./pages/RepositoryOnboardingPage"
import { RepositoryResetPage } from "./pages/RepositoryResetPage"
import { TeamPage } from "./pages/TeamPage"

const pages = {
  repositories: RepositoriesPage,
  repositoryClone: RepositoryClonePage,
  repositoryOnboarding: RepositoryOnboardingPage,
  repositoryReset: RepositoryResetPage,
  team: TeamPage
}

export function mountReactPages(root = document) {
  root.querySelectorAll("[data-react-page]").forEach((element) => {
    const Page = pages[element.dataset.reactPage]
    const propsScript = element.querySelector("[data-react-props]")

    if (!Page || !propsScript) return

    const props = JSON.parse(propsScript.textContent)
    createRoot(element).render(<Page {...props} />)
  })
}
